export enum EStudySearchTarget {
  Teachers = "Teachers",
  Students = "Students",
  Groups = "Groups",
  Reports = "Reports",
  Requests = "Requests",
}
